import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { GooglemapsService } from './googlemaps.service';

export const googlemapsInitializerResolver: ResolveFn<boolean> = (route, state) => {
  const googleMapsService = inject(GooglemapsService);
  return googleMapsService.loadGoogleMaps().pipe(
    map(() => true),
    catchError(error => {
      console.error('Error during google maps initialization: ', error);
      return of(false);
    }),
  );
};
